(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('IncidentDepartmentDialogController', IncidentDepartmentDialogController);

    IncidentDepartmentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'IncidentDepartment', 'Corporation', 'IncidentReport'];

    function IncidentDepartmentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, IncidentDepartment, Corporation, IncidentReport) {
        var vm = this;

        vm.incidentDepartment = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.incidentDepartment.id !== null) {
                IncidentDepartment.update(vm.incidentDepartment, onSaveSuccess, onSaveError);
            } else {
                IncidentDepartment.save(vm.incidentDepartment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:incidentDepartmentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
